import {type RouteLocationStringParam, type RouteRecordRaw} from 'vue-router';
import {timeTrackerMeta} from './time-tracker';

const SchoolList = () => import('../views/school/SchoolList.vue');
const SchoolEdit = () => import('../views/school/SchoolEdit.vue');

let school: RouteRecordRaw[] = [
    {
        path: '/employee/school',
        redirect: {name: 'school-list'},
    },
    {
        path: '/employee/school/list/:year?',
        name: 'school-list',
        component: SchoolList,
        meta: timeTrackerMeta,
        props(route: RouteLocationStringParam)
        {
            return {
                year: getYear(route),
            };
        },
    },
    {
        path: '/employee/school/edit/:id/:year?',
        name: 'school-edit',
        component: SchoolEdit,
        meta: timeTrackerMeta,
        props(route: RouteLocationStringParam)
        {

            return {
                id: parseInt(route.params.id),
                year: getYear(route),
            };
        },
    },
];

function getYear(route: RouteLocationStringParam)
{
    let year: string | number = route.params.year as string;
    if (!year)
    {
        let date = new Date();
        year     = date.getMonth() + 1 < 8 ? date.getFullYear() - 1 : date.getFullYear();
    }
    else
    {
        year = parseInt(year);
    }

    return year;
}

export default school;